/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
class TabNav extends React.Component {
  render() {
    return (
      <div className="row">
      <div className="col-md-2">
      <div className="box box-solid">
      <div className="box-body no-padding">
        <ul className="nav nav-pills nav-stacked">    
        {
            this.props.tabs.map(tab => {
            const active = (tab === this.props.selected ? 'active blue bg-success' : '' );
                return (
                <li className={ active } key={ tab } style={{'width':'100%'}}>
                    <a className={"nav-link " + active } onClick={ () => this.props.setSelected(tab) }>
                    { tab }
                    </a>
                </li>
                );
            })
            }                    
        </ul>
        </div>
        </div>
        </div>
        <div className="col-md-10">
        <div className="box">
            { this.props.children }
          </div>
        </div>
        </div>
           
    );
  }
}
export default TabNav;